import React from 'react';
import VideoSwitch from '../VideoSwitch';
import { Video } from 'src/typings/components/video';

const VideoFragment = ({ content, className }: { content: Video; className?: string }) => (
  <VideoSwitch players={[content.source]} currentArticle={{ video: content }} autoplay={false} className={className} />
);

export default VideoFragment;
